module.exports = __webpack_public_path__ + "img/orderbook.8549c7ae.svg";